module.exports = __webpack_public_path__ + "img/logout.6a7b2e05.svg";